<template>
  <div class="content about-advantage-wrap">
    <div class="about-banner"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/about/about-banner.png" /></div>
    <!--占位图-->
    <!--占位图-->
    <div class="about-introduct">
      <div class="interflow">
        <el-row>
          <el-col :xs="24" :lg="8">
            <div class="item">
              <img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/hutong01.png" alt="">
              <p class="txt">“专业、安全、友好、快<br />速”的清洁行业推动者</p>
            </div>
          </el-col>
          <el-col :xs="24" :lg="8">
            <div class="item">
              <img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/hutong02.png" alt="">
              <p class="txt">清洁用品采购+SaaS管理<br />的“互联网+”平台</p>
              </div>
                </el-col>
           <el-col :xs="24" :lg="8">
             <div class="item">
               <img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/hutong03.png" alt="">
               <p class="txt">中国清洁服务行业专业培训<br />的“黄埔军校"</p>
               </div>
          </el-col>
          </el-row>
      </div>
      <p class="p01" id="jianjie">企业简介</p>
      <p class="p02">
        弘范智汇隶属于北京信宇佳集团，旗下“信宇佳清洁服务、洁满仓商城、弘范智汇”三大业务版块搭建未来清洁蓝图。弘范智汇是一所在国家推广职业技能标准化建设政策背景下成立的清洁服务学院，也是国内唯一一所专业的清洁行业培训院，培训内容涵盖从服务技术、人员培训到企业管理、标准认证培训、企业定制内训服务在内的清洁服务教育全板块。学院服务于3000万清洁服务行业从业人员及全国数百家相关企业、团体，旨在打造中国清洁服务行业的“黄埔军校”。
      </p>
    </div>

    <div class="about-stand" id="yuanjing">
      <div class="stand-box">
        <el-row>
          <el-col :xs="24" :lg="12">
            <div class="item l-item"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/about/shiming.png" width="960" height="331" /></div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="item r-item">
              <el-row>
                <el-col :xs="24" :lg="24">
                  <div class="i-box">
                    <div class="tit"><svg-icon class="svg01" icon-class="yuanjing"></svg-icon></div>
                    <div class="desc">迅速提升清洁服务工作人员工作能力，提供培训效果维持方案</div>
                  </div>
                </el-col>
                <el-col :xs="24" :lg="24">
                  <div class="i-box">
                    <div class="tit"><svg-icon class="svg02" icon-class="shiming"></svg-icon></div>
                    <div class="desc">从清洁企业管理者到一线服务人员，满足企业全方位人才需求</div>
                  </div>
                </el-col>
                <el-col :xs="24" :lg="24">
                  <div class="i-box">
                    <div class="tit"><svg-icon class="svg03" icon-class="jiazhi"></svg-icon></div>
                    <div class="desc">引入行业标准，通过标准认证提升企业竞争力</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="about-founder">
      <div class="about-hd">创始人简介</div>
      <div class="founder-box">
        <el-row>
          <el-col :xs="24" :lg="12">
            <div class="f-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/about/jianjie.png" /></div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="f-info">
              <p>
                张红女士作为弘范学院的创始人，是一位从业26年的清洁服务专家，也是国内清洁行业实践&理论研究的第一人。在其主导下创办的《现代物业·现代清洁》杂志，对行业产生了十分积极的影响。同时其也是“信宇佳”清洁服务和“洁满仓”清洁采购用品管理平台以及CSTTT
                清洁行业培训师项目的创始人。
              </p>

              <p>
                除丰富的专业履历外，张红女士还在许多行业组织内任职或享有名誉头衔，包括：注册国际职业培训师ACI认证；北京建筑设施服务企业协会会长；国开大学学分认证中心清洁专业专家组长；全国15家地方清洁行业协会专家顾问；全国首部清洁服务教材《国家职业标准·保洁员》制定人；人社部《保洁员》国家职业资格培训教程主编；《清洁服务技术》清洁行业职业技能等级认定培训教材主编；国家服务标准委员会清洁服务分技术委员会副秘书长。
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="about-contactus" id="lianxi">
      <div class="about-hd">联系我们</div>
      <div class="contactus-box">
        <el-row>
          <el-col :xs="24" :lg="12">
            <div class="contact-info">
              <p class="p01">地址：</p>
              <p class="p02">北京市西三环南路14号院首科大厦1215</p>
              <p class="p01">业务咨询：</p>
              <p class="p02">400-618-3958</p>
              <p class="p01">邮箱：</p>
              <p class="p02">hongfanzhihui@163.com</p>
              <p class="p01">商业合作：</p>
              <p class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/about/qcode.png" /></p>
            </div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="contact-form" id="myform">
              <el-form :model="formInline" ref="formInline" :rules="rules">
                <el-row>
                  <el-col :sm="24" :xs="24">

                    <el-form-item prop="name"><el-input v-model="formInline.name" placeholder="您的姓名"></el-input></el-form-item>
                  </el-col>
                  <el-col :sm="24" :xs="24">

                    <el-form-item prop="phone"><el-input v-model="formInline.phone" placeholder="您的联系方式"></el-input></el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :sm="24" :xs="24">

                    <el-form-item prop="course">
                      <el-select v-model="formInline.course" placeholder="您感兴趣的课程" style="width: 100%;">

                        <template v-for="(item, index) in courses">
                          <el-option :label="item.title" :value="item.name"></el-option>
                        </template>
                      </el-select>
                    </el-form-item>

                    <el-form-item prop="remark"><el-input type="textarea" v-model="formInline.remark" placeholder="请描述您的需求"></el-input></el-form-item>
                  </el-col>
                </el-row>

                <el-form-item><el-button @click="onSubmit('formInline')">提交</el-button></el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: domain.apiUrl,
      rules:{

        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[0-9]{10}$/, //正则
          message: '请输入正确的手机号'
        }],
        course: [{
          required: true,
          message: '请选择兴趣课程',
          trigger: 'blur'
        }],
      },
      formInline: {
        name: '',
        phone:"",
        remark:"",
        course: ''
      },
      courses:[]
    };
  },
  created() {
    this.courseList();
  },
  methods: {
    onSubmit(form) {
      this.$refs[form].validate((valid,obj) => {
        if (valid) {
          this.$http.get(this.path + 'message/add',{params:this.formInline}).then((response) => {
            if(response.status === 200) {
              this.$message.success("提交成功");
            }
          }, (response) => {
            this.$message.error("error")
          });
        } else {
          return false;
        }
      });
    },
    courseList: function() {
      this.$http.get(this.path + 'course/list?type=1').then((response) => {
        if(response.status === 200) {
          this.courses = response.body;
        }
      }, (response) => {
        this.$message.error("error")
      });
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/aboutus.scss';
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue